<template>
<div class="page">
    <b-card class="mb-2">
        <b-spinner class="align-middle"></b-spinner>
        <div class="text-center">
            處理中...
        </div>
    </b-card>
</div>
</template>
<script>
import abbottAndMixin from "@/mixins/liff/proj/abbott-and";
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [abbottAndMixin],
  components: {},
  async mounted() {
    console.log("[AND SendCoupon] ========== SendCoupon.vue mounted() ==========");
    console.log("[AND SendCoupon] Route params:", this.$route.params);
    console.log("[AND SendCoupon] Route query:", this.$route.query);
    await this.init();
  },
  data() {
    return {
      lineData: {},
    };
  },
  computed: {
    ...mapGetters({
      queryData: "projAbbottAnd/queryData",
      couponType: "projAbbottAnd/couponType",
    }),
  },
  methods: {
    ...mapActions('projAbbottAnd', ['setQuery']),
    async init() {
      console.log("[AND SendCoupon] init() -> calling submit()");

      // j4 流程：qrcode 只保留後六碼
      if (this.couponType === 'j4' && this.queryData.qrcode && this.queryData.qrcode.length > 6) {
        this.setQuery({
          ...this.queryData,
          qrcode: this.queryData.qrcode.slice(-6),
        });
      }

      await this.submit()
    },
  }
}
</script>

<style lang="scss"></style>
